import { useEffect, useState, useCallback } from 'react';
import { supabase } from '../services/supabaseClient';

export const useNews = () => {
  const [news, setNews] = useState([]);
  const [userCities, setUserCities] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchNews = useCallback(async () => {
    try {
      setLoading(true);
      const { data: { user } } = await supabase.auth.getUser();
      
      const cities = (user?.user_metadata?.cities || "")
        .split(',')
        .map(city => city.trim().toLowerCase())
        .filter(Boolean);
      
      setUserCities(cities);

      const { data, error } = await supabase
        .from('news')
        .select('*')
        .eq('published', true);

      if (error) throw error;

      if (data) {
        const now = new Date();
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

        const filtered = data.filter(item => {
          if (!item.location) return false;

          const start = new Date(item.starts_at);
          const end = item.ends_at ? new Date(item.ends_at) : null;
          
          // Lógica de expiración: un día después del starts_at (si no hay end) o del ends_at
          const expirationDate = new Date(end ? end : start);
          expirationDate.setDate(expirationDate.getDate() + 1);

          if (today >= expirationDate) return false;

          const newsLocs = item.location.split(',').map(l => l.trim().toLowerCase());
          return newsLocs.includes('bolivia') || cities.some(c => newsLocs.includes(c));
        });
        
        setNews(filtered);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchNews();
  }, [fetchNews]);

  return { news, userCities, loading, refresh: fetchNews };
};